import { DocumentStatus } from '@synergy/models';
import { createSelector } from 'reselect';

import { AppState } from '../../../store/models/app-state';

const getInquiryState = (state: AppState) => state.inquiry;

export const inquiriesSelector = createSelector(getInquiryState, state => ({
    ...state.inquiries,
    items: state.inquiries.items.map(inquiry => ({
        ...inquiry,
        status:
            inquiry.status === DocumentStatus.CompletedWithTransition ||
            inquiry.status === DocumentStatus.CompletedWithoutTransition
                ? DocumentStatus.Completed
                : inquiry.status,
    })),
}));
